import shallow from 'zustand/shallow'
import { useUiStore } from '../../app/hooks'
import useIsMobile from '../../app/hooks/useIsMobile'

/**
 * Provides a boolean if the panel
 * is condensed and setter function
 * @returns [boolean, function]
 */
export default () => {
  const isMobile = useIsMobile()
  return useUiStore(
    state => [isMobile ? false : state.panelCondensed, state.togglePanelCondensed],
    shallow
  )
}
